<style lang="scss">
.el-card__body:empty {
	display: none;
}
</style>
<style lang="scss" scoped>
@include component(employee-rules) {
	@include part(header) {
		height: 50px;
		@include flex-center;
		@include part(text) {
			margin-left: 20px;
			width: 25%;
		}
	}
	@include part(text) {
		padding: 20px;
		text-align: center;
	}
}
</style>
<template lang="pug">
el-card.employee-rules
	.clearfix(slot='header')
		.employee-rules__header
			el-switch(v-model='active')
			.employee-rules__header__text Sync staff
			el-alert(v-if='isDirty' type="error" center :closable="false") Some existing matches may be discarded when changing rules
		loading(v-if='$apollo.loading')
</template>

<script>
import _ from "lodash";
import gql from "graphql-tag";
export default {
	data() {
		return {
			active: null,
			original: { active: null }
		};
	},

	computed: {
		isDirty() {
			return this.original.active === true && this.original.active !== this.active;
		}
	},

	watch: {
		active() {
			this.$emit("input", {
				active: this.active
			});
		}
	},

	apollo: {
		active: {
			query: gql`
				{
					Settings {
						employee_active
					}
				}
			`,
			fetchPolicy: "no-cache",
			update(r) {
				this.original.active = r.Settings.employee_active;
				return r.Settings.employee_active;
			}
		}
	}
};
</script>

